export class TabLoop {

    private container!:JQuery<HTMLElement>;
    private static loops:TabLoop[]=[];
    private focusable!:JQuery<HTMLElement>;
    private keyDownHandler=(ev:JQuery.TriggeredEvent)=>this.keyDown(ev);

    constructor(e:JQuery<HTMLElement>|string) {
        if (typeof e=='string') e=$(e);
        let existing = TabLoop.loops.find(x=>x.container.is(e));
        if (existing) return existing;
        this.clean();
        TabLoop.loops.push(this);
        this.container=e;
        this.setFocusableTriggerElements();
        $(document).on('keydown',this.keyDownHandler);
    }

    public focus() {
        this.focusable[1].focus();
    }

    private keyDown(ev:JQuery.TriggeredEvent) {
        if (ev.key != "Tab") return;

        let idx=TabLoop.loops.indexOf(this);
        if (idx!==TabLoop.loops.length-1) return;

        if (this.focusable.first().is(ev.target)) {
            if (ev.shiftKey) {
            ev.preventDefault();
                this.focusable.last().focus();
                return;
            }
        }
        if (this.focusable.last().is(ev.target)) {
            if (!ev.shiftKey) {
                ev.preventDefault();
                this.focusable.first().focus();
                return;
            }
    }
        if (!this.focusable.is(ev.target)) {
        ev.preventDefault();
            if (ev.shiftKey) {
                this.focusable.last().focus();
            } else {
                this.focusable.first().focus();
            }
    }
    }

    private setFocusableTriggerElements() {
        if (!this.container || !this.container.length) return;
        let element = this.container[0];

        let focusableSelector='a[href], button, input, textarea, select, details,[tabindex]:not([tabindex="-1"]):not([disabled]):not([aria-hidden])';
        this.focusable = this.container.find(focusableSelector);
    }

    destroy() {
        let index = TabLoop.loops.findIndex(x=>x.container.is(this.container));
        $(document).off('keydown',this.keyDownHandler);
        TabLoop.loops.splice(index,1);
    }

    private clean() {
        let existingInstances:TabLoop[]=[];
        for (let inst of TabLoop.loops) {
            if ($('body').has(inst.container[0]).length) {
                existingInstances.push(inst);
            } else {
                inst.destroy();
            }
        }
        TabLoop.loops=existingInstances;
    }
}

export {};